/* Emporio Orgánika — comportamiento del theme */
(function () {
  var d = document;

  function dinero(centavos, moneda) {
    try {
      return new Intl.NumberFormat(d.documentElement.lang || 'es-CL', {
        style: 'currency', currency: moneda || 'CLP'
      }).format((Number(centavos) || 0) / 100);
    } catch (e) {
      return '$' + Math.round((Number(centavos) || 0) / 100).toLocaleString('es-CL');
    }
  }

  /* ---- Altura real del header ---- */
  function altoHeader() {
    var h = d.querySelector('[data-om-header]');
    if (h) d.documentElement.style.setProperty('--om-head-h', h.offsetHeight + 'px');
  }
  altoHeader();
  window.addEventListener('resize', altoHeader);

  /* ---- Navegación móvil ---- */
  d.querySelectorAll('[data-om-header]').forEach(function (cabecera) {
    var boton = cabecera.querySelector('[data-om-menu-toggle]');
    var menu = cabecera.querySelector('[data-om-menu]');
    if (!boton || !menu) return;

    function cerrar() {
      cabecera.classList.remove('is-menu-open');
      boton.setAttribute('aria-expanded', 'false');
      var etiqueta = boton.querySelector('.om-sr');
      if (etiqueta) etiqueta.textContent = 'Abrir menú';
      altoHeader();
    }

    boton.addEventListener('click', function () {
      var abrir = !cabecera.classList.contains('is-menu-open');
      cabecera.classList.toggle('is-menu-open', abrir);
      boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      var etiqueta = boton.querySelector('.om-sr');
      if (etiqueta) etiqueta.textContent = abrir ? 'Cerrar menú' : 'Abrir menú';
      altoHeader();
    });
    menu.addEventListener('click', function (ev) { if (ev.target.closest('a')) cerrar(); });
    cabecera.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { cerrar(); boton.focus(); }
    });
  });

  d.querySelectorAll('[aria-disabled="true"]').forEach(function (enlace) {
    enlace.addEventListener('click', function (ev) { ev.preventDefault(); });
  });

  /* ---- Aviso flotante ---- */
  var toast = d.querySelector('[data-om-toast]'), tTimer;
  function avisar(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  /* ---- Carro AJAX ---- */
  function refrescarCarro() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (c) {
        d.querySelectorAll('[data-om-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
        return c;
      })
      .catch(function () {});
  }

  function agregar(items, msg, boton) {
    if (!items.length) return Promise.resolve();
    if (boton) boton.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refrescarCarro(); })
      .then(function () { avisar(msg); })
      .catch(function (e) { avisar((e && (e.description || e.message)) || 'No se pudo agregar al carro'); })
      .then(function () { if (boton) boton.disabled = false; });
  }

  /* ---- Ficha de producto: galería, packs y compra ---- */
  d.querySelectorAll('[data-om-product]').forEach(function (raiz) {
    var radios = raiz.querySelectorAll('[data-om-pack]');
    var extras = raiz.querySelector('[data-om-extras]');
    var selects = raiz.querySelectorAll('[data-om-extra]');
    var moneda = raiz.getAttribute('data-currency') || 'CLP';
    var precioBase = Number(raiz.getAttribute('data-base-price')) || 0;
    var umbral = Number(raiz.getAttribute('data-free-shipping')) || 1;

    function activo() {
      return raiz.querySelector('[data-om-pack]:checked') || radios[0];
    }

    function calculo(radio) {
      var cantidad = parseInt(radio.getAttribute('data-cantidad'), 10) || 1;
      var bruto = precioBase;
      for (var i = 0; i < cantidad - 1; i++) {
        var opcion = selects[i] && selects[i].options[selects[i].selectedIndex];
        bruto += opcion ? (Number(opcion.getAttribute('data-price')) || precioBase) : precioBase;
      }
      var descuento = cantidad === 2
        ? Number(raiz.getAttribute('data-discount-duo')) || 0
        : cantidad === 3 ? Number(raiz.getAttribute('data-discount-trio')) || 0 : 0;
      return { cantidad: cantidad, bruto: bruto, descuento: descuento, total: Math.max(0, bruto - descuento) };
    }

    function pintar() {
      var seleccionado = activo();
      if (!seleccionado) return;

      radios.forEach(function (radio) {
        var res = calculo(radio);
        var tarjeta = radio.closest('.om-pack');
        tarjeta.classList.toggle('is-on', radio === seleccionado);
        var precio = tarjeta.querySelector('.om-pack__precio b');
        if (precio) precio.textContent = dinero(res.total, moneda);
      });

      var actual = calculo(seleccionado);
      raiz.querySelectorAll('[data-om-total], [data-om-cta-precio]').forEach(function (n) {
        n.textContent = dinero(actual.total, moneda);
      });

      var antes = raiz.querySelector('[data-om-antes]');
      var wrapAhorro = raiz.querySelector('[data-om-ahorro-wrap]');
      var ahorro = raiz.querySelector('[data-om-ahorro]');
      if (wrapAhorro) wrapAhorro.style.display = actual.descuento > 0 ? 'inline-flex' : 'none';
      if (antes) antes.textContent = dinero(actual.bruto, moneda);
      if (ahorro) ahorro.textContent = dinero(actual.descuento, moneda);

      var barra = raiz.querySelector('[data-om-envio-barra]');
      var txt = raiz.querySelector('[data-om-envio-txt]');
      var falta = Math.max(0, umbral - actual.total);
      if (barra) barra.style.width = Math.min(100, actual.total * 100 / umbral) + '%';
      if (txt) txt.textContent = falta > 0 ? 'Te faltan ' + dinero(falta, moneda) + ' para el envío gratis' : 'Envío gratis incluido';

      if (extras) extras.classList.toggle('is-on', actual.cantidad > 1);
      selects.forEach(function (select, i) {
        var visible = i < actual.cantidad - 1;
        select.closest('.om-select').style.display = visible ? '' : 'none';
        select.disabled = !visible;
      });
    }

    radios.forEach(function (radio) { radio.addEventListener('change', pintar); });
    selects.forEach(function (select) { select.addEventListener('change', pintar); });
    pintar();

    var fotoPrincipal = raiz.querySelector('[data-om-main-image]');
    raiz.querySelectorAll('[data-om-product-image]').forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        if (!fotoPrincipal) return;
        fotoPrincipal.src = miniatura.getAttribute('data-om-product-image');
        fotoPrincipal.alt = miniatura.getAttribute('data-om-product-alt') || '';
        raiz.querySelectorAll('[data-om-product-image]').forEach(function (b) {
          var on = b === miniatura;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });

    raiz.querySelectorAll('[data-om-add]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var radio = activo();
        var items = [{ id: Number(raiz.getAttribute('data-variant-id')), quantity: 1 }];
        selects.forEach(function (select) {
          if (!select.disabled && select.value) items.push({ id: Number(select.value), quantity: 1 });
        });
        var faltan = calculo(radio).cantidad - items.length;
        while (faltan-- > 0) items.push({ id: Number(raiz.getAttribute('data-variant-id')), quantity: 1 });
        agregar(items, (radio.getAttribute('data-nom') || 'Producto') + ' agregado al carro', btn);
      });
    });

    var principal = raiz.querySelector('.om-pdp__info [data-om-add]');
    function estadoSticky() {
      if (!principal || window.innerWidth >= 900) return raiz.classList.remove('is-sticky-atc');
      var rp = principal.getBoundingClientRect();
      raiz.classList.toggle('is-sticky-atc', rp.bottom < 0);
    }
    window.addEventListener('scroll', estadoSticky, { passive: true });
    window.addEventListener('resize', estadoSticky);
    estadoSticky();
  });

  /* ---- Dúo de la home ---- */
  d.querySelectorAll('[data-om-duo]').forEach(function (raiz) {
    var swatches = Array.prototype.slice.call(raiz.querySelectorAll('[data-om-duo-sw]:not([disabled])'));
    var segundo = raiz.querySelector('[data-om-duo-second]');
    if (!swatches.length || !segundo) return;
    var indice = 0;
    var moneda = raiz.getAttribute('data-currency') || 'CLP';
    var descuento = Number(raiz.getAttribute('data-discount')) || 0;

    function opcionSegundo() { return segundo.options[segundo.selectedIndex]; }
    function elegirSegundoDistinto(idPrimero) {
      if (segundo.value !== idPrimero && !opcionSegundo().disabled) return;
      for (var i = 0; i < segundo.options.length; i++) {
        if (!segundo.options[i].disabled && segundo.options[i].value !== idPrimero) {
          segundo.selectedIndex = i;
          return;
        }
      }
    }

    function pintarDuo() {
      var primero = swatches[indice];
      elegirSegundoDistinto(primero.getAttribute('data-variante'));
      var otro = opcionSegundo();
      swatches.forEach(function (x, k) {
        x.classList.toggle('is-on', k === indice);
        x.setAttribute('aria-pressed', k === indice ? 'true' : 'false');
      });
      var set = function (sel, fn) { raiz.querySelectorAll(sel).forEach(fn); };
      set('[data-om-duo-color]', function (n) { n.style.background = primero.getAttribute('data-color'); });
      set('[data-om-duo-color2]', function (n) { n.style.background = otro.getAttribute('data-color'); });
      set('[data-om-duo-nom]', function (n) { n.textContent = primero.getAttribute('data-nom'); });
      set('[data-om-duo-nom2]', function (n) { n.textContent = otro.getAttribute('data-nom'); });
      set('[data-om-duo-precio]', function (n) { n.textContent = primero.getAttribute('data-precio'); });
      set('[data-om-duo-precio2]', function (n) { n.textContent = otro.getAttribute('data-precio'); });
      set('[data-om-duo-bot]', function (n) { if (primero.getAttribute('data-bot')) n.src = primero.getAttribute('data-bot'); });
      set('[data-om-duo-foto]', function (n) {
        var f = primero.getAttribute('data-foto');
        if (f) { n.src = f; n.style.display = ''; } else { n.style.display = 'none'; }
      });
      set('[data-om-duo-foto2]', function (n) {
        var f = otro.getAttribute('data-foto');
        if (f) { n.src = f; n.style.display = ''; } else { n.style.display = 'none'; }
      });
      set('[data-om-duo-slot2]', function (n) { n.style.display = otro.getAttribute('data-foto') ? 'none' : ''; });

      var bruto = (Number(primero.getAttribute('data-price-cents')) || 0) + (Number(otro.getAttribute('data-price-cents')) || 0);
      var total = Math.max(0, bruto - descuento);
      var totalNodo = raiz.querySelector('[data-om-duo-total]');
      var antesNodo = raiz.querySelector('[data-om-duo-before]');
      if (totalNodo) totalNodo.textContent = dinero(total, moneda);
      if (antesNodo) {
        antesNodo.textContent = dinero(bruto, moneda);
        antesNodo.style.display = descuento > 0 ? '' : 'none';
      }
      raiz.setAttribute('data-om-duo-ids', primero.getAttribute('data-variante') + ',' + otro.value);
    }

    swatches.forEach(function (x, k) { x.addEventListener('click', function () { indice = k; pintarDuo(); }); });
    segundo.addEventListener('change', pintarDuo);
    pintarDuo();

    raiz.querySelectorAll('[data-om-add-duo]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var ids = (raiz.getAttribute('data-om-duo-ids') || '').split(',').filter(Boolean);
        if (ids.length < 2) return avisar('Falta configurar los aromas');
        agregar(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), 'Dos aromas agregados al carro', btn);
      });
    });
  });

  /* ---- Total del dúo en la ficha ---- */
  d.querySelectorAll('[data-om-value-stack]').forEach(function (raiz) {
    var select = raiz.querySelector('[data-om-add-extra]');
    var totalNodo = raiz.querySelector('[data-om-stack-total]');
    var base = Number(raiz.getAttribute('data-base-price')) || 0;
    var descuento = Number(raiz.getAttribute('data-discount')) || 0;
    var moneda = raiz.getAttribute('data-currency') || 'CLP';
    function actualizarStack() {
      var precioExtra = base;
      if (select && select.selectedIndex >= 0) {
        precioExtra = Number(select.options[select.selectedIndex].getAttribute('data-price')) || base;
      }
      var total = Math.max(0, base + precioExtra - descuento);
      if (totalNodo) totalNodo.textContent = dinero(total, moneda);
      var boton = raiz.querySelector('[data-om-add-simple]');
      if (boton) boton.setAttribute('data-om-msg', 'Dos aromas agregados · ' + dinero(total, moneda));
    }
    if (select) select.addEventListener('change', actualizarStack);
    actualizarStack();
  });

  /* ---- Añadir al carro simple ---- */
  d.querySelectorAll('[data-om-add-simple]').forEach(function (btn) {
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      var ids = (btn.getAttribute('data-om-add-simple') || '').split(',').filter(Boolean);
      var caja = btn.closest('section') || d;
      caja.querySelectorAll('[data-om-add-extra]').forEach(function (select) { if (select.value) ids.push(select.value); });
      if (ids.length === 1 && btn.getAttribute('data-om-quantity') !== '1') ids.push(ids[0]);
      if (!ids.length) return avisar('Falta configurar un producto disponible');
      agregar(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), btn.getAttribute('data-om-msg') || 'Agregado al carro', btn);
    });
  });

  /* ---- Experiencia sensorial piloto ---- */
  d.querySelectorAll('[data-om-sensory]').forEach(function (raiz) {
    var momentos = Array.prototype.slice.call(raiz.querySelectorAll('[data-om-sense-moment]'));
    var escena = raiz.querySelector('[data-om-sense-scene]');
    var spray = raiz.querySelector('[data-om-spray]');
    var titulo = raiz.querySelector('[data-om-sense-title]');
    var texto = raiz.querySelector('[data-om-sense-text]');
    var despues = raiz.querySelector('[data-om-sense-after]');
    var estado = raiz.querySelector('[data-om-sense-state]');
    var status = raiz.querySelector('[data-om-sense-status]');
    var resultado = raiz.querySelector('[data-om-sense-result-copy]');
    var timer;
    var completo = false;
    if (!escena || !spray || !momentos.length) return;

    function reiniciar() {
      clearTimeout(timer);
      completo = false;
      raiz.classList.remove('is-charging', 'is-complete');
      escena.classList.remove('is-transformed');
      spray.setAttribute('aria-pressed', 'false');
      if (estado) estado.textContent = raiz.getAttribute('data-initial-state') || 'Antes del aroma';
      if (status) status.textContent = raiz.getAttribute('data-waiting-state') || 'La escena está esperando';
    }

    function elegir(boton) {
      momentos.forEach(function (x) {
        var activo = x === boton;
        x.classList.toggle('is-on', activo);
        x.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      if (titulo) titulo.textContent = boton.getAttribute('data-title') || '';
      if (texto) texto.textContent = boton.getAttribute('data-text') || '';
      if (despues) despues.textContent = '“' + (boton.getAttribute('data-after') || '') + '”';
      if (resultado) resultado.textContent = boton.getAttribute('data-after') || '';
      reiniciar();
    }

    function completar() {
      clearTimeout(timer);
      completo = true;
      raiz.classList.remove('is-charging');
      raiz.classList.add('is-complete');
      escena.classList.add('is-transformed');
      spray.setAttribute('aria-pressed', 'true');
      if (estado) estado.textContent = 'Después del aroma';
      if (status) status.textContent = 'El aroma entró en la escena';
    }

    function comenzar(ev) {
      if (ev && ev.type === 'keydown' && ev.key !== ' ' && ev.key !== 'Enter') return;
      if (ev && ev.type === 'keydown') {
        ev.preventDefault();
        if (!completo) completar(); else reiniciar();
        return;
      }
      if (completo) return reiniciar();
      clearTimeout(timer);
      raiz.classList.add('is-charging');
      if (status) status.textContent = 'Deja que la sensación entre…';
      var espera = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 80 : 900;
      timer = setTimeout(completar, espera);
    }

    function soltar(ev) {
      if (ev && ev.type === 'keyup' && ev.key !== ' ' && ev.key !== 'Enter') return;
      clearTimeout(timer);
      if (!completo) {
        raiz.classList.remove('is-charging');
        if (status) status.textContent = 'Mantén un poco más para completar la escena';
      }
    }

    momentos.forEach(function (boton) { boton.addEventListener('click', function () { elegir(boton); }); });
    spray.addEventListener('pointerdown', comenzar);
    spray.addEventListener('pointerup', soltar);
    spray.addEventListener('pointerleave', soltar);
    spray.addEventListener('pointercancel', soltar);
    spray.addEventListener('keydown', comenzar);
    spray.addEventListener('keyup', soltar);
  });
})();
